import React, { useEffect, useState } from 'react';
import { BCAsideItem } from './BCAsideItem';
import { translate } from '../../Services/translation';
import { useBCApi } from './hooks/BCApi';

export const BCAside = ({ tabs, selectedTab, setSelectedTab }) => {
    const [minimized, setMinimized] = useState(false);
    const { value } = useBCApi('/api/bcmypages/sidebar', true);
    const { companyName, companyLogoUrl } = value || {};

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    function handleWindowSizeChange() {
        setIsMobile(window.innerWidth < 768);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);

    return (
        <div className={`BCAside ${minimized ? 'BCAside__minimized' : ''}`}>
            {companyLogoUrl ? (
                <img
                    src={companyLogoUrl}
                    alt={translate('business.aside.companylogo')}
                    className="BCAside__logo"
                />
            ) : null}
            <p className="BCAside__company-name">
                {companyName ?? translate('business.aside.mypages')}
            </p>
            {isMobile && (
                <div
                    className="BCAside__toggle-height"
                    onClick={() => setMinimized(!minimized)}
                >
                    <i
                        className={`BCAside__toggle-height__${
                            minimized ? 'minimized' : 'maximized'
                        }`}
                    />
                </div>
            )}
            <div className="BCAside__items-container">
                {Object.keys(tabs).map((tab, index) => (
                    <BCAsideItem
                        key={index}
                        id={tab}
                        logo={tabs[tab].icon}
                        onClick={setSelectedTab}
                        isSelected={selectedTab === tab}
                        label={translate(`${tabs[tab].name}`)}
                        isMinimized={minimized}
                    />
                ))}
                <a href="/login.Logout" className="BCAsideItem">
                    <i className="BCAsideItem__icon__logout BCAsideItem__icon" />
                    <p className="BCAsideItem__name">
                        {translate('business.sidebar.logout')}
                    </p>
                </a>
            </div>
            {!isMobile && (
                <div
                    className="BCAside__toggle-width"
                    onClick={() => setMinimized(!minimized)}
                >
                    <i
                        className={`BCAside__toggle-width__${
                            minimized ? 'minimized' : 'maximized'
                        }`}
                    />
                </div>
            )}
        </div>
    );
};
